<template>
  <div
    v-if="user"
    class="md-layout avatar-with-level"
  >
    <div class="md-layout-item avatar">
      <easy-circular-progress
        :value="(getProgressValue(user.level ? user.level : 1, user.points ? user.points : 0)) * 100"
        stroke-color="#DF263B"
        :radius="50"
        :stroke-width="10"
      >
        <div class="content">
          <img
            class="user-avatar"
            :src="user.image ? user.image : '/img/default-avatar.png'"
            alt="user avatar"
          >
          <div class="hexagon">
            <img :src="'/img/hexagon.svg'">
            <span class="level">{{ user.level ? user.level : 1 }}</span>
          </div>
        </div>
      </easy-circular-progress>
    </div>
    <div class="user-info">
      <span class="user-name">{{ user.firstname }} {{ user.lastname }}</span>
      <span class="display-name">{{ user.displayName }}</span>
    </div>
  </div>
</template>

<script>
import level from "../../utils/level";

export default {
  name: 'AvatarWithLevelInfo',
  props: {
    user: {
      type: Object
    }
  },
  methods: {
    ...level,
    getProgressValue(currentLevel, currentPoints) {
      const levelInterval = this.calculateLevelPoints(currentLevel);
      const upperBound = levelInterval[1];
      const lowerBound = levelInterval[0];
      const range = upperBound - lowerBound + 1;
      const gainedPoints = currentPoints - lowerBound;

      const percentage = gainedPoints / range;

      return percentage;
    },

  }
}
</script>

<style lang="scss" scoped>
.avatar-with-level {
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  .avatar {
    display: flex;
    justify-content: center;
  }
  .user-avatar {
    border-radius: 50%;
  }
  .user-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    .user-name {
      font-weight: 500;
      font-size: 24px;
    }
    .display-name {
      font-weight: 400;
      font-size: 14px;
      color: #8C7272;
    }
  }
  .content {
    width: 94px;
    height: 94px;
    border-radius: 50%;
    position: relative;
    left: 13px;
    bottom: 3px;
    display: flex;
    align-items: center;
    border: 3px solid white;
    img {
      height: fit-content;
    }
  }
}
.vue-circular-progress {
  stroke-opacity: 0.1 !important;
}
.hexagon {
  width: 28px;
  height: 28px;
  position: absolute;
  top: 66px;
  right: -2px;
  .level {
    position: relative;
    top: -30px;
    color: white;
  }
}
</style>